<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <Configurations />
  </v-container>
</template>
<script>
import Configurations from "../components/Configurations.vue";
export default {
  components: {
    Configurations
  },
  created() {
    if (!this.hasRole(this.AdminUserPermissions.SETTINGS_VIEW)) {
      this.$router.push({
        name: "Error404"
      });
    }
  }
};
</script>
